import { makeStyles } from "@material-ui/core/styles";
import { themeOptions } from "styles/theme";

export const useStyles = makeStyles({
    container: {
        fontSize: "1.3rem",
        color: themeOptions.palette.textColor,
    },
    title: {
        fontWeight: "bold",
        marginBottom: "24px",
    },
    tabInfo: {
        marginBottom: "17px",
    },
    insightsLink: {
        color: "#00807B",
        textDecoration: "underline",
    },
    description: {
        paddingTop: "20px",
        paddingBottom: "5px",
    },
});
